<template>
  <main class="modal-main">
    <div class="prod-popup no-padding">
      <div class="step-padding">
        <div class="t_999 t_center fs-26">第 {{ stepCount }} 步 (共 {{ stepCount }} 步)</div>
        <div class="t_title">
          返回淘宝APP进行付款后，复制订单编号，回到此页面，点击提交订单
        </div>
        <div class="t_hlep no-border">
          如有疑问，请点击
          <span class="t_blue" @click="showCourse">常见问题</span>
        </div>
      </div>
      <div class="step-padding mar-top">
        <div class="three-height" v-if="dataInfo">
          <div class="t_key space-between guide-coupon" v-if="dataInfo.IsCoupon">
            <div class="shrink t_999">淘宝详情页领券：</div>
            <span class="coupon-tag-sure">{{ dataInfo.CouponAmount }}元券</span>
          </div>
          <div class="t_key space-between" v-if="dataInfo.FreightType">
            <div class="shrink t_999">运费（商品不包邮）：</div>
            <div class="flex">￥{{ dataInfo.Freight ? dataInfo.Freight.toFixed(2) : '' }}</div>
          </div>
          <div class="t_key space-between guide-price">
            <div class="shrink t_999">{{ dataInfo.IsCoupon ? '券后付款金额' : '付款金额' }}：</div>
            <div class="flex-center">
              <div class="feeback-btn" @click="showDiff({ taskID: taskID, dataInfo: dataInfo, platform: 0 })">差价反馈</div>
              <div>￥{{ dataInfo.ProductPrice ? dataInfo.ProductPrice.toFixed(2) : '' }}</div>
              <!-- <div class='key_tags'>￥{{dataInfo.ProductPrice}}</div> -->
            </div>
          </div>
          <div class="t_key status2">
            <div class="t_key__main space-between">
              <div class="shrink t_999">收货后返利：</div>
              <div class="flex">￥{{ dataInfo.BuyRebatePrice ? dataInfo.BuyRebatePrice.toFixed(2) : '' }}</div>
            </div>
            <el-alert v-if="dataInfo.BlockCouponFeePermission" title="请勿使用红包，否则订单无法提交成功" type="warning" :closable="false" style="margin-top: 10px;" show-icon> </el-alert>
          </div>
          <div class="rist_tip" @click="riskDialogShow = true">
            垫付是否有风险？
          </div>
        </div>
        <div class="step_two">
          <div class="step_img" @click="previewImg">
            <img :src="youpPath + step3Img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tc_button">
      <div class="tc_btn shPrimaryBtn" @click="entoOrderMerge">提交订单</div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="youpPath + step3Img"> </preview-dialog>
    <!-- 垫付保障弹窗 -->
    <risk-dialog v-if="riskDialogShow" @close="riskDialogShow = false"> </risk-dialog>
    <!-- 新手引导 -->
    <div>
      <template v-if="guideCouponShow">
        <div class="through-showbox coupon-through" :style="couponStyle"></div>
        <div class="tool-tip">
          <img class="through-img coupon-th-img" :src="stepThree1Img" alt="" />
          <div class="through-btn through-coupon-btn" :style="couponBtnStyle" @click="nextGuide('coupon')">
            <img :src="nextBtnImg" alt="" />
          </div>
        </div>
      </template>
      <template v-if="guidePriceShow">
        <div class="through-showbox price-through" :style="priceStyle"></div>
        <div class="tool-tip">
          <img class="through-img" :style="priceImgStyle" :src="stepThree2Img" alt="" />
          <div class="through-btn through-price-btn" :style="priceBtnStyle" @click="nextGuide('price')">
            <img :src="nextBtnImg" alt="" />
          </div>
        </div>
      </template>
      <template v-if="guideImgShow">
        <div class="through-showbox img-through" :style="imgStyle"></div>
        <div class="tool-tip">
          <img class="through-img" :style="imgTooltipStyle" :src="stepThree3Img" alt="" />
          <div class="through-btn through-img-btn" :style="imgBtnStyle" @click="guideClose">
            <img :src="knowBtnImg" alt="" />
          </div>
        </div>
      </template>
    </div>
  </main>
</template>

<script>
import feedbackBtnEvent from '@/mixins/feedbackBtnEvent'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import RiskDialog from '@/components/puppetComponent/RiskDialog'
import { OrderStep3InfoGet } from '@/api/detailPage'
import Utils from '@/utils/base'
import { Alert } from 'element-ui'
export default {
  mixins: [feedbackBtnEvent],
  data() {
    return {
      youpPath: IMG_BASE_URL,
      step3Img: '/upaiyun/Sys/20191120/5406146395129497961.png',
      previewDialogShow: false,
      dataInfo: {},
      stepCount: 3,
      baseModeEnter: 0, // 是否从基础模式进入
      // 保障弹窗
      riskDialogShow: false,
      // 新手引导
      stepThree1Img: IMG_BASE_URL + '/upaiyun/Sys/20190829/5225975793110009678.png',
      stepThree2Img: IMG_BASE_URL + '/upaiyun/Sys/20190829/5626238921346879282.png',
      stepThree3Img: IMG_BASE_URL + '/upaiyun/Sys/20190829/5494622426869379115.png',
      nextBtnImg: IMG_BASE_URL + '/upaiyun/Sys/20190829/4820414849684349799.png',
      knowBtnImg: IMG_BASE_URL + '/upaiyun/Sys/20190829/5157027486024063296.png',
      boxElem: null,
      guideCouponShow: false,
      guidePriceShow: false,
      guideImgShow: false,
      couponStyle: null,
      couponBtnStyle: null,
      priceStyle: null,
      priceImgStyle: null,
      priceBtnStyle: null,
      imgStyle: null,
      imgTooltipStyle: null,
      imgBtnStyle: null
    }
  },
  components: {
    PreviewDialog,
    RiskDialog,
    'el-alert': Alert
  },
  created() {
    this.taskID = this.$route.query.readyTaskId
  },
  mounted() {
    this.boxElem = document.querySelector('.prod-popup')
    if (this.taskID) {
      this.fetchData()
    } else {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      OrderStep3InfoGet({ taskId: this.taskID })
        .then((res) => {
          this.dataInfo = res.Data
          Indicator.close()
          let guideSession = Utils.getNewGuideSession()
          if (guideSession.isNewHand && !guideSession.stepThree) {
            this.showNewsGuide()
          } else {
            if (this.dataInfo.IsFirstBuy && !guideSession.stepThree) {
              // this.showNewsGuide()
            }
          }
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
            if (res.ErrMsg === '未将对象引用设置到对象的实例。') {
              this.$router.replace({ name: 'souhuo' })
            }
          }
        })
    },
    showNewsGuide() {
      if (this.dataInfo.IsCoupon) {
        this.setGuideStyle('.guide-coupon', 'coupon')
        this.guideCouponShow = true
      } else {
        this.setGuideStyle('.guide-price', 'price')
        this.guidePriceShow = true
      }
      Utils.setNewGuideSession({
        isNewHand: true,
        stepOne: true,
        questionOne: true,
        questionTwo: true,
        questionThree: true,
        stepThree: true
      })
    },
    // 预览
    previewImg() {
      this.previewDialogShow = true
    },
    // 查看教程
    showCourse() {
      this.$router.push({
        name: 'courseStep',
        query: {
          indexStep: 3
        }
      })
    },
    // 差价反馈
    diffPriceFeedback() {
      this.$router.push({
        name: 'diffPeiceFeedback',
        query: {
          taskID: this.taskID
        }
      })
    },
    // 步骤三 提交订单 跳转页面
    entoOrderMerge() {
      let queryObj = { taskID: this.taskID }
      if (this.baseModeEnter) queryObj.basemode = this.baseModeEnter
      this.$router.push({
        name: 'orderSubmit',
        query: queryObj
      })
    },
    // 动态设置引导css
    setGuideStyle(className, type) {
      this.$nextTick(() => {
        let elem = document.querySelector(className)
        if (type === 'coupon') {
          this.couponStyle = { top: elem.offsetTop + 5 + 'px' }
          this.couponBtnStyle = {
            top: elem.offsetTop + elem.clientHeight + 'px'
          }
        } else if (type === 'price') {
          this.priceStyle = {
            height: elem.clientHeight + 'px',
            top: elem.offsetTop + 'px',
            borderRadius: Math.ceil(elem.clientHeight / 2) + 'px'
          }
          this.priceImgStyle = { top: elem.offsetTop + 'px' }
          this.priceBtnStyle = { top: elem.offsetTop + 150 + 'px' }
        } else {
          // 屏幕小时要减去已滚动的高度
          let boxScrollTop = this.boxElem.scrollTop || 0
          this.imgStyle = {
            width: elem.clientWidth + 'px',
            height: elem.clientHeight + 'px',
            top: elem.offsetTop - boxScrollTop + 'px',
            left: elem.offsetLeft + 'px'
          }
          this.imgTooltipStyle = {
            top: elem.offsetTop - 180 - boxScrollTop + 'px',
            left: elem.offsetLeft - 90 + 'px'
          }
          this.imgBtnStyle = { top: elem.offsetTop - 50 - boxScrollTop + 'px' }
        }
      })
    },
    nextGuide(val) {
      if (val === 'coupon') {
        this.setGuideStyle('.guide-price', 'price')
        this.guideCouponShow = false
        this.guidePriceShow = true
      } else {
        this.boxElem.scrollTop = document.scrollingElement.scrollHeight
        this.setGuideStyle('.step_img > img', 'img')
        this.guideCouponShow = false
        this.guidePriceShow = false
        this.guideImgShow = true
      }
    },
    guideClose() {
      this.boxElem.scrollTop = 0
      this.guideImgShow = false
    }
  },
  beforeRouteEnter(to, from, next) {
    let routeNames = ['stepOne', 'stepTwo', 'questionThree', 'order', 'courseStep', 'diffPeiceFeedback', 'baseStepOne', 'checkPeiceFeedback']
    // 如果是从淘宝基础模式第一步进入，则允许订单页面回退
    let isBaseModeBack = parseInt(from.query.basemode || 0)
    if (routeNames.indexOf(from.name) !== -1 || isBaseModeBack) {
      next((vm) => {
        if (from.name === 'baseStepOne' || isBaseModeBack) {
          vm.baseModeEnter = 1
          vm.stepCount = 2
        } else {
          vm.baseModeEnter = 0
        }
      })
    } else {
      next({ name: 'souhuo' })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.baseModeEnter && (to.name === 'courseStep' || to.name === 'diffPeiceFeedback')) {
      to.query.basemode = 1
    }
    next()
  }
}
</script>

<style scoped lang="scss">
@import '../../step.scss';
.three-height {
  min-height: auto;
}
.coupon {
  height: 35px;
  padding-bottom: 2%;
  border-bottom: 1px solid #eee;
}
.rist_tip {
  width: 100%;
  text-align: right;
  color: #3399ff;
  cursor: pointer;
  padding-top: 5px;
}
.mar-top {
  margin-top: 1vh;
  padding-top: 0;
}
.flex-center {
  display: flex;
  align-items: center;
}
.t_key {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  &__main {
    display: flex;
    width: 100%;
  }
  &.status2 {
    flex-direction: column;
  }
}
.feeback-btn {
  background: #409eff;
  color: #fff;
  height: 24px;
  line-height: 24px;
  border-radius: 15px;
  padding: 0 8px;
  box-sizing: border-box;
  margin-right: 5px;
}
/* 新手引导 */
.coupon-through {
  height: 35px;
  width: 80px;
  border-radius: 5px;
  right: 2%;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.coupon-th-img {
  top: -4vh;
  right: -50px;
}
.through-coupon-btn {
  top: 21vh;
  right: 1.5vh;
}
.price-through {
  width: 96%;
  left: 50%;
  transform: translateX(-50%);
}
.through-price-btn {
  top: 47vh;
  right: 2vh;
}
.through-img-btn {
  right: 0vh;
  top: 32vh;
}
@media screen and (max-width: 320px) {
  .coupon-th-img {
    top: -7vh;
  }
  .through-coupon-btn {
    top: 25vh;
  }
  .through-price-btn {
    top: 52vh;
  }
  .tool-tip .through-img-btn {
    width: 110px;
    right: -1vh;
    top: 37vh;
  }
}
@media screen and (min-height: 812px) {
  .through-img-btn {
    top: 26vh;
  }
}
</style>
